import React from 'react';
import { ExampleResponse } from '../components/ExampleResponse';

type ProjectPlanFormSectionProps = {
  title: string;
  description?: string;
  required?: boolean;
  children: React.ReactNode;
  exampleContent?: React.ReactNode;
};

export const ProjectPlanFormSection = ({
  title,
  description,
  required,
  children,
  exampleContent,
}: ProjectPlanFormSectionProps) => (
  <div className='flex flex-col gap-3'>
    <div className='flex flex-col gap-1'>
      <span className="text-base font-semibold leading-6 text-gray-700">
        {title}
        {required && <span className='text-red-500'> *</span>}
      </span>
      {description && (
        <span className="text-sm font-normal leading-5 text-gray-500">{description}</span>
      )}
    </div>
    {children}
    {exampleContent && <ExampleResponse>{exampleContent}</ExampleResponse>}
  </div>
);

